import { styled } from '@mui/system'

export const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
